import { Injectable, EventEmitter } from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { ActivatedRoute } from '@angular/router';
import { PlatformCommand, ContentScope } from '@shared/commands/command-base';
import { DialogModel } from '@shared/models/dialog.model';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';
import { DialogService } from '@shared/services/dialog-service';
import { Store } from '@ngrx/store';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';

@Injectable({
  providedIn: 'root',
})

export class PlatformToolDac6ArrangementDetailHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  activatedRoute?: ActivatedRoute;
  metaData?: any;

  item: any;
  id: string;
  constructor(
    private dialogService: DialogService,
    private collaborationStore: Store<CollaborationState>,
    private fileStoreCommonService: FileStoreCommonService) {
      this.invalidateSubject = new InvalidateSubject();
    }

  executeCommand(command: PlatformCommand) {
    this.item = this.magicLinkModel.fieldValues['item'];
    this.id = this.item.id;
    console.log(command);
    switch (command.name) {
      case 'ArrangementDetailOpenConversationCommand':
        this.openConversation();
        break;
      case 'ArrangementDetailViewDocumentsCommand':
        this.navigateToCaseFolder();
        break;
      case 'ArrangementDetailHallmarkTaggingCommand':
        this.openHallmarkTagging();
        break;
    }
  }
  openConversation() {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: this.item.cells['CaseGUID'].value,
        caseId: this.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${this.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      this.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  navigateToCaseFolder() {
    let relativePath = 'DAC6 Reporter/[CASE_ID]/Arrangements';
    const caseId = this.item.cells['CaseId'].value;
    relativePath = relativePath.replace('[CASE_ID]', caseId);
    this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
  }
  openHallmarkTagging() {
    const dialogueModel = DialogModel.create('Hallmark Tagging', 'HallmarkTagSuggestionDialogComponent', {'Id':this.id});
    dialogueModel.maxWidth = '600px';
    dialogueModel.minWidth = '600px';
    this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
      if (res.data.action === 'nevigateToHallmark') {
      }
    });
  }
  valueChanged($event: any) {

  }
  setSelectedTab(selectedTab: TabModel): void {
    console.log(this.magicLinkModel);
  }
  destroy(): void {

  }
  selectionChanged?($event: any): void {

  }
  onFieldSectionChanged?($event: any): void {

  }
  onFieldSectionIndexChanged?($event: any): void {

  }
}
